module.exports = __webpack_public_path__ + "media/photography/sectionBackground-f4a5db91.png";